import React, { useMemo } from "react";
import cx from "classnames";
import type { PickemsContestWithMarkets } from "@/hooks/firestore/pickems/usePickemsContest";
import { useEntry } from "@/hooks/firestore/betting/useEntries";
import PickSlipFooterAction from "./PickSlipFooterAction";
import { usePotentialPoints } from "@/features/pickems/hooks/usePotentialPoints";
import { usePickslipStore } from "@/features/pickems/stores/pickslipStore";

import * as styles from "./PickSlip.module.scss";

type PickSlipFooterProps = {
  contest: PickemsContestWithMarkets;
  hasMadeAllPicks: boolean;
  canMakePick: boolean;
  pickCount: number;
  marketCount: number;
};

const PickSlipFooter = ({
  contest,
  hasMadeAllPicks,
  canMakePick,
  pickCount,
  marketCount,
}: PickSlipFooterProps) => {
  const { entry } = useEntry({ entryId: contest.id });
  const safeEntry = contest.id ? entry : undefined;

  const pointsPotential = usePotentialPoints(contest, safeEntry);
  const justAccepted = usePickslipStore((state) => state.justAccepted);

  // intentionally exclude existingPickCount to avoid flicker
  const leftLabel = useMemo(() => {
    return justAccepted ? "Picks" : hasMadeAllPicks ? "Changes" : "Picks";
  }, [justAccepted]);

  return (
    <div className={styles.footer}>
      <div className={styles.info}>
        <div className={styles.panel}>
          <div className={styles.label}>{leftLabel}</div>
          <div className={cx(styles.value, styles.pickCount)}>
            <div className={styles.numeric}>{pickCount}</div>
            <span className={styles.slash}>/</span>
            <div className={styles.numeric}>{marketCount}</div>
          </div>
        </div>
        <div className={cx(styles.panel, styles.right)}>
          <div className={styles.label}>Points</div>
          <div className={styles.value}>{pointsPotential} PTS</div>
        </div>
      </div>
      <div className={styles.buttons}>
        <PickSlipFooterAction
          contest={contest}
          entry={safeEntry}
          canMakePick={canMakePick}
          hasMadeAllPicks={hasMadeAllPicks}
        />
      </div>
    </div>
  );
};

export default PickSlipFooter;
